<template>
  <div class="timetable1">
     <Header :title="this.tittleName+'课表'" type='0' :route="'/teacher/surCuseAll_Find?searchVal='+this.$route.query.searchVal+'&searchName='+this.$route.query.searchName+'&findType='+this.$route.query.findType+'&singcont='+this.$route.query.singcont"></Header>
      <div class="timetable_top1">
        <van-field readonly clickable placeholder="周次" v-model="curWeek" @click="showPicker = true;change = false"/>
        <i class="week-arrow"></i>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" :item-height="35" :default-index="defaultIndex"/>
        </van-popup>
        <div class="time-right">
          <!-- 时间模式 -->
          <van-field readonly clickable placeholder="" v-model="timeMode" @click="modePicker = true"/>
          <van-popup v-model="modePicker" position="bottom">
            <van-picker show-toolbar :columns="modeColumns" @cancel="modePicker = false" @confirm="modeConfirm" :item-height="35" :default-index="defaultIndex1"/>
          </van-popup>
          <div v-if="schoolCode=='12981'&&sjtype=='1'" class="currentTime_sj" @click="showSj('0')">全部</div>
          <div v-if="schoolCode=='12981'&&sjtype=='0'" class="currentTime_sj_active" @click="showSj('1')">实践</div>
          <div class="currentTime" @click="findNowTime(nowzc)">今</div>
        </div>
      </div>
      <div class="timetable_list">
        <div class="period" style="margin-bottom: 70px">
          <div style="width: 45px">{{this.nowMonth}}<br>月</div>
          <ul>
          	<li style="width: 45px" v-for="(item,index) in jcNameList" :key="index"><span>{{item.djmc}}</span></li>
          </ul>
        </div>
        <div class="table-right">
          <div class="week-nav">
            <ul>
              <li :style="curDay == item.xqmc && (('第'+nowzc+'周') == curWeek) ? 'background-color:#12DDD6' : ''" v-for="(item,index) in weekNameList" :key="index">
                <span>{{item.xqmc}}</span>
                <p v-if="item.zc != 'all' ">{{dateSub(item.mxrq)}}</p>
              </li>
            </ul>
          </div>
         
          <div class="course-content">

             <!-- 第一天 -->
            <div class="course-form" id="firstday">
              <ul class="myul">
                <li ref="ranText" @click="courseDetail(item,item.jx0404id,index,item.xq,1)" v-for="(item,index) in dataObj_one" :key="index" :style="item.jx0404id!='-1' ? 'height:140px;' + 'background-color:' + calcColor(index,0) : ''">
                  <span v-show="item.jx0404id!='-1'">{{item.kcmc}} - {{item.skjgxm}} @ {{item.jsmc}}
                  </span>
                  <span v-show="item.jx0404id=='-1'"></span>
                </li>
              </ul>
            </div>
            <!-- 第二天-->
            <div class="course-form" id="monday">
              <ul class="myul">
          	     <li ref="ranText" @click="courseDetail(item,item.jx0404id,index,item.xq,2)" v-for="(item,index) in dataObj_tow" :key="index" :style="item.jx0404id!='-1' ? 'height:140px;' + 'background-color:' + calcColor(index,1) : ''">
                  <span v-show="item.jx0404id!='-1'">{{item.kcmc}} - {{item.skjgxm}} @ {{item.jsmc}}
                  </span>
                  <span v-show="item.jx0404id=='-1'"></span>
                </li>
             </ul>
            </div>

            <!-- 第三天-->
            <div class="course-form" id="monday">
              <ul class="myul">
          	     <li ref="ranText" @click="courseDetail(item,item.jx0404id,index,item.xq,3)" v-for="(item,index) in dataObj_three" :key="index" :style="item.jx0404id!='-1' ? 'height:140px;' + 'background-color:' + calcColor(index,0) : ''">
                  <span v-show="item.jx0404id!='-1'">{{item.kcmc}} - {{item.skjgxm}} @ {{item.jsmc}}
                  </span>
                  <span v-show="item.jx0404id=='-1'"></span>
                </li>
             </ul>
            </div>

            <!-- 第四天-->
            <div class="course-form" id="monday">
              <ul class="myul">
          	     <li ref="ranText" @click="courseDetail(item,item.jx0404id,index,item.xq,4)" v-for="(item,index) in dataObj_fourth" :key="index" :style="item.jx0404id!='-1' ? 'height:140px;' + 'background-color:' + calcColor(index,1) : ''">
                  <span v-show="item.jx0404id!='-1'">{{item.kcmc}} - {{item.skjgxm}} @ {{item.jsmc}}
                  </span>
                  <span v-show="item.jx0404id=='-1'"></span>
                </li>
             </ul>
            </div>

            <!-- 第五天-->
            <div class="course-form" id="monday">
              <ul class="myul">
          	     <li ref="ranText" @click="courseDetail(item,item.jx0404id,index,item.xq,5)" v-for="(item,index) in dataObj_five" :key="index" :style="item.jx0404id!='-1' ? 'height:140px;' + 'background-color:' + calcColor(index,0) : ''">
                  <span v-show="item.jx0404id!='-1'">{{item.kcmc}} - {{item.skjgxm}} @ {{item.jsmc}}
                  </span>
                  <span v-show="item.jx0404id=='-1'"></span>
                </li>
             </ul>
            </div>

            <!-- 第六天-->
            <div class="course-form" id="monday">
              <ul class="myul">
          	     <li ref="ranText" @click="courseDetail(item,item.jx0404id,index,item.xq,6)" v-for="(item,index) in dataObj_six" :key="index" :style="item.jx0404id!='-1' ? 'height:140px;' + 'background-color:' + calcColor(index,1) : ''">
                  <span v-show="item.jx0404id!='-1'">{{item.kcmc}} - {{item.skjgxm}} @ {{item.jsmc}}
                  </span>
                  <span v-show="item.jx0404id=='-1'"></span>
                </li>
             </ul>
            </div>

            <!-- 第七天-->
            <div class="course-form" id="monday">
              <ul class="myul">
          	     <li ref="ranText" @click="courseDetail(item,item.jx0404id,index,item.xq,7)" v-for="(item,index) in dataObj_seven" :key="index" :style="item.jx0404id!='-1' ? 'height:140px;' + 'background-color:' + calcColor(index,0) : ''">
                  <span v-show="item.jx0404id!='-1'">{{item.kcmc}} - {{item.skjgxm}} @ {{item.jsmc}}
                  </span>
                  <span v-show="item.jx0404id=='-1'"></span>
                </li>
             </ul>
            </div>


          </div>

        </div>
      </div>
      <van-popup v-model="popShow" class="popup">
        <h2><i class="close-pop" @click="popShow = false"></i></h2>
        <url class="deal_url">
          <li v-for="(item,index) in this.curData_all" :key="index">
             <p v-if="item.isjsjy=='0'"><span class='deal_tittle'>课程名称：</span><span>{{item.kcmc}}</span></p>
             <p v-if="item.isjsjy=='1'"><span class='deal_tittle'>借用原因：</span><span>{{item.kcmc}}</span></p>
             <p><span class='deal_tittle'>时间：</span><span >{{item.xqname}}{{item.jc}}({{item.kkzc}}周)</span></p>
             <p><span class='deal_tittle'>地点：</span><span>{{item.jsmc}}</span></p>
             <p><span class='deal_tittle'>教师：</span><span>{{item.skjgxm}}</span></p>
             <p v-if="item.issyk=='1'"><span class='deal_tittle'>批次名称：</span><span>{{item.pcmc}}</span></p>
             <p v-else><span class='deal_tittle'>课堂名称：</span><span>{{item.ktmc}}</span></p>
             <p v-if="item.issyk=='0'"><span class='deal_tittle'>上课人数：</span><span>{{item.rs}}</span></p>
             <p v-else><span class='deal_tittle'>实验人数：</span><span>{{item.rs}}</span></p>
          </li>
          
        </url>
      </van-popup>

         <van-popup v-model="popShow_student" class="popup_student">
      <h2><i class="close-pop" @click="popShow_student = false"></i>学生名单</h2>
      <div class="student-tittle-div">
        <ul class="ul-student">
          <li class="li-student">姓名</li>
          <li class="li-student">学号</li>
          <li class="li-student">班级</li>
        </ul>
      </div>

       <div class="student-context-div " v-for="(item,index) in studentsList" :key="index">
        <ul  v-if="index%2==0" class="ul-student-context div-backclor1">
          <li class="li-student-context ">{{item.xm}}</li>
          <li class="li-student-context">{{item.xh}}</li>
          <li class="li-student-context">{{item.bj}}</li>
        </ul>
         <ul  v-if="index%2!=0" class="ul-student-context div-backclor2">
          <li class="li-student-context ">{{item.xm}}</li>
          <li class="li-student-context">{{item.xh}}</li>
          <li class="li-student-context">{{item.bj}}</li>
        </ul>
      </div>
    </van-popup>

  </div>
</template>

<script>
  import { Api } from '../../../utils/axios'
  export default {
	  data(){
      return{
        schoolCode:sessionStorage.getItem("schoolCode"),
        casLogin:sessionStorage.getItem('casLogin'),
        timetable:[],
        popShow:false,
        popShow_student:false,
        defaultIndex:0,
        defaultIndex1:0,
        curWeek: '',
        timeMode:'',
        showPicker: false,
        modePicker: false,
        modeColumns:[],
        modeIdColumns:[],
        timeModeId:this.$route.query.kbsjmsid,
        columns: [{
					values: [],
					className: 'column1'
        }],
        curDay:'',
        colorList:["#FF8282","#EE7BFF","#FFBB79","#FF87B3","#86B5FF"],
        colorList1:["rgba(118,107,255,.7)","#757DA3","rgba(255,84,147,.4)","#B3B9D0","rgba(95,222,255,.7)"],
        change:true,
        studentsList:[],
        //一周第一天的一个课程数据
        dataObj_one:[],
        //一周第二天的一个课程数据
        dataObj_tow:[],
        //一周第三天的一个课程数据
        dataObj_three:[],
        //一周第四天的一个课程数据
        dataObj_fourth:[],
        //一周第五天的一个课程数据
        dataObj_five:[],
        //一周第六天的一个课程数据
        dataObj_six:[],
        //一周第七天的一个课程数据
        dataObj_seven:[],

        //一周第一天的所有课程数据
        dataObj_one_all:[],
        //一周第二天的所有课程数据
        dataObj_tow_all:[],
        //一周第三天的所有课程数据
        dataObj_three_all:[],
        //一周第四天的所有课程数据
        dataObj_fourth_all:[],
        //一周第五天的所有课程数据
        dataObj_five_all:[],
        //一周第六天的所有课程数据
        dataObj_six_all:[],
        //一周第七天的所有课程数据
        dataObj_seven_all:[],
        //节次名称
        jcNameObj:[],
        //当前月
        nowMonth:"",
        //当前周次
        nowWeekend:"",
        //周次列表
        zcList:[],
        //时间列表
        dateList:[],
        //节次名称列表
        jcNameList:[],
        //星期名称列表,
        weekNameList:[],
        //课表数据
        curDataList:[],
        curData_all:[],
        tittleName:"",
        nowzc:"",
        sjtype:'0'
      }
	  },
    methods:{
      calcColor(index,type){
        // let num = parseInt(Math.random()*5)
        let num = (Math.abs(index - 2))%5;
        let num1 =(Math.abs(index - 4))%5;
         if(type == 0){
            return this.colorList[num]
          }else{
            return this.colorList1[num1]
        }
      },
      modeConfirm(val,index){
        this.modePicker = false
        let isChange = "0";
        if(this.timeModeId!=this.modeIdColumns[index]){
          isChange = "1";
        }
        this.timeMode = val
        this.timeModeId = this.modeIdColumns[index];
        if(isChange=="1"){
          this.initData();
        }
      },
      async toSeeStudents(data){
        this.popShow_student=true;
        const params = {
          jx0404id:data.jx0404id
        }
       const res = await Api.getStudentByTD(params);
       this.studentsList = res.data;
      },
      async courseDetail(info,flag,index,xq,dayIndex){
        if(flag!=-1){
          let jcName = this.jcNameList[index].jcVale;
          if(dayIndex==1){
            this.curData_all = this.dataObj_one_all[index];
          }else if(dayIndex==2){
            this.curData_all = this.dataObj_tow_all[index];
          }else if(dayIndex==3){
            this.curData_all = this.dataObj_three_all[index];
          }else if(dayIndex==4){
            this.curData_all = this.dataObj_fourth_all[index];
          }else if(dayIndex==5){
            this.curData_all = this.dataObj_five_all[index];
          }else if(dayIndex==6){
            this.curData_all = this.dataObj_six_all[index];
          }else if(dayIndex==7){
            this.curData_all = this.dataObj_seven_all[index];
          }
          console.log(this.curData_all);
          this.popShow = true;
        }
      },
      goBack(){
        this.$router.push({
        path: "/teacher/surCuseAll_Find",
        query: {
          findType:this.$route.query.findType,
          searchVal:this.$route.query.searchVal,
          searchName:this.$route.query.searchName,
          xnxq:this.$route.query.xnxq,
          kbsjmsid:this.$route.query.kbsjmsid,
        }
       });
      },
      dateSub(res){
        return Number(res.substr(-2,2))
      },
      calcOpt(val,type){
        let num = Number(val.substr(1,2))-1;
        //top
        if(type == 0){
          return num*70 + 'px;'
        //height
        }else{
          if(val.length == 11){
            return 209 + 'px;'
          }else if(val.length == 3){
            return 69 + 'px;'
          }else if(val.length == 15){
            return 279 + 'px;'
          }else if(val.length == 7){
            return 139 + 'px;'
          }
        }
      },
      async onConfirm(value,index) {
        let isChange = "0";
        if(this.curWeek!=value){
          isChange = "1";
        }
        this.showPicker = false;
        this.curWeek = value;
        //this.defaultIndex = index;
        if(isChange=="1"){
          this.initData();
        }
      },
      classList2(arr,newArr){
         for(let i in arr){
            let abc = arr[i]
            for(let n in newArr){
              if(newArr[n].a == abc.weekNoteDetail.slice(-2)){
                newArr[n] = abc
              }
            }
          }
        return newArr
      },
      clearObj(){
            this.dataObj_one=[];
            this.dataObj_tow=[];
            this.dataObj_three = [];
            this.dataObj_fourth = [];
            this.dataObj_five = [];
            this.dataObj_six = [];
            this.dataObj_seven = [];
            this.dataObj_one_all = [];
            this.dataObj_tow_all = [];
            this.dataObj_three_all = [];
            this.dataObj_fourth_all = [];
            this.dataObj_five_all = [];
            this.dataObj_six_all = [];
            this.dataObj_seven_all = [];
      },
      findNowTime(weekVal){
        if(weekVal==""){
          return;
        }
        this.curWeek = "第"+weekVal+"周";
        this.initData();
      },
      async initData(){
       let zc = this.curWeek+"";
       if(zc=="全部"){
         zc = "all";
       }else if(zc!=""){
         zc = zc.substr(1);
         zc = zc.substr(0,zc.length-1);
       }
       let kbsjmsid_tmp = this.timeModeId;
       this.clearObj();
      const params = {
          xnxq:this.$route.query.xnxq,
          kbsjmsid:kbsjmsid_tmp,
          searchVal:this.$route.query.searchVal,
          findType:this.$route.query.findType,
          searchZc:zc,
          isSjkc:this.sjtype
        }
       const res = await Api.getCurAllData(params);
       if(res.code=='1'){
         this.nowMonth = res.data.dqMonth;
         this.nowWeekend = res.data.dqzc;
         this.nowzc = res.data.dqzc;
         this.curDay = res.data.dqxingqi;
         this.zcList = res.data.zcList;
         this.jcNameList = res.data.jcNameList;
         this.weekNameList = res.data.weekNameList;
         this.curDataList = res.data.curDataList;
         //console.log(this.curDataList);
         //组装每一天的课表数据
         if(this.curDataList&&this.curDataList.length>0){
           this.dataObj_one_all = this.curDataList[0];
           this.dataObj_tow_all = this.curDataList[1];
           this.dataObj_three_all = this.curDataList[2];
           this.dataObj_fourth_all = this.curDataList[3];
           this.dataObj_five_all = this.curDataList[4];
           this.dataObj_six_all = this.curDataList[5];
           this.dataObj_seven_all = this.curDataList[6];
           let tempList2 = this.dataObj_tow_all[2];
           for(let i=0;i<this.jcNameList.length;i++){
             let tempList1 = this.dataObj_one_all[i];
             if(tempList1&&tempList1.length>0){
               this.dataObj_one.push(tempList1[0]);
             }else{
               this.dataObj_one.push({"jx0404id":"-1"});
             }

             let tempList2 = this.dataObj_tow_all[i];
             if(tempList2&&tempList2.length>0){
               this.dataObj_tow.push(tempList2[0]);
             }else{
               this.dataObj_tow.push({"jx0404id":"-1"});
             }

             let tempList3 = this.dataObj_three_all[i];
             if(tempList3&&tempList3.length>0){
               this.dataObj_three.push(tempList3[0]);
             }else{
               this.dataObj_three.push({"jx0404id":"-1"});
             }

             let tempList4 = this.dataObj_fourth_all[i];
             if(tempList4&&tempList4.length>0){
               this.dataObj_fourth.push(tempList4[0]);
             }else{
               this.dataObj_fourth.push({"jx0404id":"-1"});
             }

             let tempList5 = this.dataObj_five_all[i];
             if(tempList5&&tempList5.length>0){
               this.dataObj_five.push(tempList5[0]);
             }else{
               this.dataObj_five.push({"jx0404id":"-1"});
             }

             let tempList6 = this.dataObj_six_all[i];
             if(tempList6&&tempList6.length>0){
               this.dataObj_six.push(tempList6[0]);
             }else{
               this.dataObj_six.push({"jx0404id":"-1"});
             }

             let tempList7 = this.dataObj_seven_all[i];
             if(tempList7&&tempList7.length>0){
               this.dataObj_seven.push(tempList7[0]);
             }else{
               this.dataObj_seven.push({"jx0404id":"-1"});
             }
           }
           console.log(this.dataObj_tow);
         }
         //组装周次
         let concatList = []
        for(let i = 1;i <= this.zcList.length;i++){
          if(i==1){
            concatList = concatList.concat("全部");
            this.defaultIndex = 0;
          }
          concatList = concatList.concat("第" + i + "周");
        }
        if(this.curWeek == ""){
          if(res.data.dqzcVal!=""){
            this.curWeek = "第"+res.data.dqzcVal+"周";
          }else{
            this.curWeek = "全部";
          }
          
        }
        
        this.columns[0].values = concatList;
        //组装时间模式
        if(res.data.sjmsList.length > 0&&this.modeColumns.length==0){
          res.data.sjmsList.forEach((item,index) => {
            if(item.mrms == 1){
              this.timeMode = item.kbjcmsmc
              this.defaultIndex1 = index
              this.timeModeId = item.kbjcmsid
            }
            this.modeColumns.push(item.kbjcmsmc)
            this.modeIdColumns.push(item.kbjcmsid)
          });
        }

       }
    },
    showSj(type){
      this.sjtype = type;
      this.initData();
    }
    },
    created(){
      if(this.$route.query.findType=='0'){
        this.tittleName = "教师";
      }else if(this.$route.query.findType=='1'){
        this.tittleName = "班级";
      }else if(this.$route.query.findType=='2'){
        this.tittleName = "课程";
      }else if(this.$route.query.findType=='3'){
        this.tittleName = "教室";
      }
      
     this.initData();
    },
    mounted(){
      setTimeout(() => {
        if(this.$refs.ranText){
          for(let i = 0;i < this.$refs.ranText.length;i++){
            if(this.$refs.ranText[i].children && this.$refs.ranText[i].children.length == 3){
              this.$refs.ranText[i].children[2].style.color = this.$refs.ranText[i].style.backgroundColor
            }
          }
        }
      },250)
    },
  }
</script>

<style lang="less" scoped>
.timetable1{
  .timetable_top1{
    /deep/.van-field__control{
      color: #ffffff;
    }
  }
  .popup {
    i.close-pop{
      background: url(../../../../static/img/close.png)no-repeat center;
      position: absolute;right: 0;top: -10px;background-size:20px 20px;
      width: 20px;height: 20px;padding: 10px;
    }
  }
  .link-item{text-decoration: underline;word-break: break-all;}
}
  .timetable1 .van-popup.van-popup--center{box-sizing: border-box;padding: 20px;width: 90%;border-radius: 5px;}
  .timetable1 .van-popup.van-popup--center>h2{color: @attendance-color-1;font-size: 16px;text-align: center;font-weight: bold;margin-bottom: 20px;position: relative;}
  .timetable1 .van-popup.van-popup--center>div{color: @attendance-background-color-1;font-size: 24px;font-weight: bold;text-align: center;padding-top: 10px;padding-bottom: 10px;}
  .timetable1 .van-popup.van-popup--center>p{color: @attendance-color-2;font-size: 16px;line-height: 30px;}
  .timetable1 .popup button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;border-radius: 3px;width: 100%;margin-top: 50px;}
  .timetable1 .van-popup.van-popup--center>p>span{font-weight: bold;}
  .timetable1 .timetable_top1{display: flex;justify-content: space-between;align-items: center;background: @attendance-background-color-1;padding: 10px 15px;}
  .timetable1 .timetable_top1 select{color: @attendance-color-3;border: 0;background: none;outline: none;}
  .timetable1 .timetable_top1 .currentTime{width: 25px;height: 25px;line-height: 25px;
    font-weight: 300;color: @attendance-color-3;font-size: 14px;text-align: center;border-radius: 50%;background: @attendance-background-color-8;}
  .timetable1 .timetable_list{display: flex;background-color:@attendance-background-color-6;}
  .timetable1 .timetable_list .period>div{border: 1px solid @attendance-border-color-5;border-bottom: 0;box-sizing: border-box;font-size: 14px;text-align: center;box-shadow:1px 1px 4px 0px rgba(62,53,167,0.26);background: @attendance-border-color-5;color: @attendance-color-3;box-shadow:1px 1px 4px 0px rgba(62,53,167,0.26);height: 60px;width: 45px;display: flex;align-items: center;justify-content: center;}
  .timetable1 .timetable_list .period ul li{height: 140px;text-align: center;}
  .timetable1 .timetable_list .period ul li span{display:inline-block;vertical-align: middle;margin-top: 50px;}
  .timetable1 .el-tabs__nav .is-top{background: @attendance-border-color-5;color: @attendance-color-3;}
  .timetable1 .table_list ul li{width: 62px;height: 115px;background: @attendance-background-color-9;color: @attendance-color-3;box-sizing: border-box;padding:5px; font-size: 12px;border-radius: 2px;}
  .timetable1 .timetable_top1 .van-cell{background-color: @attendance-background-color-1 !important;color: @attendance-color-3;padding: 0;width: 15%;}
  .timetable1 .timetable_top1 .van-field__body .van-field__control{color: @attendance-color-3 !important;}
  .timetable1 .timetable_top1 .van-cell:not(:last-child)::after{border-bottom: 0;}
  .timetable1 .week-arrow{background: url(../../../../static/img/week.png)no-repeat center;width: 7px;height: 4px;background-size: 7px 4px;position: absolute;left: 70px;}
  .timetable1 .timetable1 .timetable_top1 .van-ellipsis.van-picker-column__item.van-picker-column__item--selected{color: @attendance-color-1;font-weight: 600;}
  .timetable1 .table-right{flex: 1;overflow-x:scroll;}
  .timetable1 .table-right .week-nav ul li{flex-direction: column; height: 60px;background-color: @attendance-border-color-5;color: @attendance-color-3;display: flex;justify-content: center;align-items: center;width:15%;}
  .timetable1 .table-right .week-nav ul li>p{font-size: 14px;margin-top: 3px;}
  .timetable1 .table-right .week-nav ul{display: flex;border-bottom: 1px solid @attendance-color-3;min-width: 435px;max-width: 100%;}
  .timetable1 .el-tabs__nav{width: 100%;}
  .timetable1 .period ul li{color: @attendance-color-2;}
  .timetable1 .course-content{display: flex;min-width: 435px;max-width: 100%;}
  .timetable1 .course-form{width:15%;position: relative}
  .timetable1 .course-form ul{display: flex;flex-direction: column;}
  .timetable1 .course-form .myul{position: absolute;top: 0;left: 0;z-index: 1;width: 100%;border-right: 1px solid @attendance-color-3;}
  .timetable1 .course-form .myul li{
    overflow: hidden; width: calc(~"100% - 1px");position: relative; height: 139px;
    color: @attendance-color-3;font-size: 12px;padding:8px 4px; margin-bottom: 1px;
    border-radius: 4px;word-wrap:break-word;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    /* -webkit-line-clamp: 8; */
    box-sizing: border-box;
    margin-right: 1px;
  }
  .timetable1 .course-form .myul li>p{
    border-radius: 9px;background-color: rgba(255,255,255,.5);font-size: 10px;text-align: center;padding: 2px 0;position: absolute;bottom: 4px;left: 2px;width: calc(~"100% - 4px");box-sizing: border-box;
    line-height: 14px;
  }
  .timetable1 .pos_item{
    position: absolute;
    top: 0;
    left: -9px;
  }
  .timetable1 .pos_item li{
    width: 58px;
    height: 65px;
    color: @attendance-color-3;
    margin-bottom: 1px;
    border-radius: 4px 4px 4px 4px;
    font-size: 12px;
    padding: 4px;
  }
  /* 时间模式 */
  .time-right{display: flex;justify-content: flex-end;position: relative;}
  .time-right .van-cell{width: calc(~"80% - 25px") !important;}
  .time-right .van-field__control{text-align: right;padding-right: 25px;}
  .time-right i.week-arrow{right: 35px;left: unset;height: 100%;}

 .popup_student {
    i.close-pop{
      background: url(../../../../static/img/close.png)no-repeat center;
      position: absolute;right: 0;top: -10px;background-size:20px 20px;
      width: 20px;height: 20px;padding: 10px;
    }
  }
   .set-part{display: flex;justify-content: space-between;}
  .set-part>div{width: 48%}
  .set-part-p{text-align: left;}
  .timetable1 .ul-student{
     width: 99%;
  }
  .timetable1 .li-student{
     width: 33%;
     float: left;
     font-size: 15px;
  }
  .student-tittle-div{
    margin-top: -10px;
  }
  .student-context-div{
    margin: 0px;
  }
  .li-student-context{
     width: 33%;
     float: left;
     font-size: 12px;
     color: black;
  }
  .ul-student-context{
    width: 99%;
    line-height: 20px;
  }
  .div-backclor1 li{
    background-color: gainsboro;
  }
  .div-backclor2 li{
background-color:antiquewhite;
  }
  .deal_url{
    list-style:none;
  }
  .deal_url p{
    margin: 4px;
  }
  .deal_url li{
    margin-bottom: 10px;
    width: 100%;
    background-color: rgba(169, 169, 169, 0.116);
    border-radius:5px;  
  }
  .deal_tittle{
    font-size: 18px;
    font-weight: bold;
  }
  .currentTime_sj{
      width: 50px;height: 25px;
      line-height: 25px;
      font-weight: 300;
      color: #8f87f9;
      font-size: 14px;
      text-align: center;
      border-radius: 15%;
      background: #F8F8F8;
    }

    .currentTime_sj_active{
      width: 50px;height: 25px;
      line-height: 25px;
      font-weight: 300;
      color: @attendance-color-3;
      font-size: 14px;
      text-align: center;
      border-radius: 15%;
      background: @attendance-background-color-8;
    }

</style>



// WEBPACK FOOTER //
// src/components/teacher/teachCuseAll/surfacesAll.vue